module.exports = __webpack_public_path__ + "static/img/helh23.347ad80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthycockpit/helh23.png
// module id = UWes
// module chunks = 4